import React from 'react';
import { useAtomValue } from 'jotai';
import { FlowDashboardWrapper, FlowWrapper } from './styled';
import Header from './Header';
import { panelsAtom } from '../atoms';
import FlowTable from './flow-table';
import ErrorBoundary from '../../common/Retry/ErrorBoundary';

const WidgetPanel = () => {
  const panels = useAtomValue(panelsAtom);

  return (
    <ErrorBoundary>
      <FlowDashboardWrapper style={{ display: panels.flows ? 'block' : 'none' }}>
        <FlowWrapper>
          <Header></Header>
          <FlowTable />
        </FlowWrapper>
      </FlowDashboardWrapper>
    </ErrorBoundary>
  );
};

export default WidgetPanel;
